'use strict';

export function snakeCase (word = '') {
  return word.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
}
